import { useEffect } from 'react'
import { DashboardPageProps } from './dashboard-page.types'
import styles from './dashboard-page.module.scss'
import cl from 'classnames'
import { StatisticsPage } from 'pages'

const DashboardPageComponent = (props: DashboardPageProps) => {
  const {
    className,
    style,
    location: { pathname },
    history: { replace }
  } = props

  useEffect(() => {
    if (pathname === '/') replace('/dashboard')
  }, [pathname, replace])

  return (
    <div className={cl(styles.container, className)} style={style}>
      <StatisticsPage isDashboard />
    </div>
  )
}

const DashboardPage = DashboardPageComponent
export { DashboardPage }
